import { Component, OnInit, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { UtilService } from '../../utils/util.service';
import { NzUploadFile } from 'ng-zorro-antd';
import { Observable, Observer, Subscription } from 'rxjs';
import { ModalConfigService } from '../../utils/modal-config.service';

/**
 * 支持表单api的文件选择组件 不需要上传文件 手动触发
 * form api
 * <app-form-file-select formControlName="name"></app-form-file-select>
 * 非 form api
 * <app-form-file-select [(fileList)]="flist"></app-form-file-select>
 */
@Component({
  selector: 'app-form-file-select',
  templateUrl: './form-file-select.component.html',
  styleUrls: ['./form-file-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormFileSelectComponent),
      multi: true
    }
  ]
})
export class FormFileSelectComponent implements OnInit, ControlValueAccessor  {
  constructor(
    private utilService: UtilService,
    private modalMessageService: ModalConfigService,
  ) { }

  @Input() fileList: any = [];
  /**
   * 上传完成回调  返回根据 入参dataType要求的格式
   */
  @Output() fileListChange = new EventEmitter();

  @Input() fileSize = null; // 文件大小上限，单位 MB
  @Input() limit = 1; // 上传数量
  @Input() disableUpload = false; // 禁用
  @Input() accept = 'jpg,jpeg,png'; // 允许上传的文件类型，如：'mp3,wav' 不要带 .
  private onChange = (value: any) => {};
  get nzAccept() {
    if (this.accept) {
      return this.accept.split(',').map((item) => this.utilService.getFileMimeType(item)).join(',');
    }
    return '';
  }

  public previewVisible = false;
  public scale = 1;


  ngOnInit() {
  }

  writeValue(fileList: any[]): void {
    this.fileList = fileList;
  }

  /**
   * 注册值变化时的回调函数
   *
   * @param fn 回调函数，当值变化时会被调用
   * @returns 无返回值
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * 注册表单控件失去焦点时的回调函数
   *
   * @param fn 回调函数
   * @returns 无返回值
   */
  registerOnTouched(fn: any): void { }

  /**
   * 设置禁用状态
   *
   * @param isDisabled 是否禁用组件
   * @returns 无返回值
   */
  setDisabledState(isDisabled: boolean): void {
    // 如果组件需要支持禁用状态，则在此处处理
    this.disableUpload = isDisabled;
  }
  // 不上传所以啥都不干手动触发
  beforeUpload = (file: NzUploadFile): boolean => {
    if (this.nzAccept) {
      const acceptList = this.nzAccept.split(',');
      if (!acceptList.includes(file.type)) {
        this.modalMessageService.errConfirm({ title: `只能上传${this.accept}格式的文件`, ok: () => {} });
        return false;
      }
    }

    if (this.fileSize) {
      if (file.size / 1024 / 1024 > this.fileSize) {
        this.modalMessageService.errConfirm({ title: `文件大小不能超过${this.fileSize}MB`, ok: () => {} });
        return false;
      }
    }
    this.fileList = this.fileList.concat(file);
    this.onFileChange(this.fileList);
    return false;
  };

  removeFile = (file: NzUploadFile) => {
    this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
    this.onFileChange(this.fileList);
    return true
  }

  onFileChange(fileList: any[]): void {
    this.onChange(fileList);
    this.fileListChange.emit(fileList);
  }
}
